import { hotRank } from "@/mocks/chigua";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line",
  down: "ri-arrow-down-line",
  flat: "ri-subtract-line",
  new: "ri-sparkling-fill",
};

export default function HotRank() {
  return (
    <section id="hot" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.7fr_1.5fr]">
        <div className="lg:sticky lg:top-24 lg:self-start">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1.5 text-xs font-medium text-primary-700">
            <i className="ri-fire-fill animate-pulse"></i> 每 5 分钟刷新
          </span>
          <h2 className="mt-3 text-3xl font-bold leading-tight text-foreground-950 md:text-4xl">
            实时更新 · 吃瓜福利热榜
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            综合讨论度、搜索量与传播速度实时排序，热度一直在变的榜单，帮你在第一时间抓住最值得聊的话题。
          </p>
          <div className="mt-6 grid grid-cols-3 gap-3">
            <div className="rounded-lg bg-accent-100 p-4 text-center">
              <div className="font-display text-3xl text-accent-700">98.6k</div>
              <div className="mt-1 text-xs text-accent-800">当前榜首热度</div>
            </div>
            <div className="rounded-lg bg-secondary-100 p-4 text-center">
              <div className="font-display text-3xl text-secondary-900">+18%</div>
              <div className="mt-1 text-xs text-secondary-800">较昨日涨速</div>
            </div>
            <div className="rounded-lg bg-background-100 p-4 text-center border border-background-200">
              <div className="font-display text-3xl text-foreground-900">10</div>
              <div className="mt-1 text-xs text-foreground-600">本期话题</div>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-2.5">
          {hotRank.map((item) => {
            const isTop = item.rank <= 3;
            return (
              <a
                key={item.rank}
                href="#latest"
                className="group flex items-center gap-3 rounded-lg bg-background-100 px-4 py-3 border border-background-200 transition-colors hover:border-primary-300 hover:bg-background-50"
              >
                <span
                  className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md font-display text-xl ${
                    isTop ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {item.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="truncate text-sm font-medium text-foreground-950 group-hover:text-primary-600 md:text-base">
                      {item.title}
                    </h3>
                    <span className="shrink-0 rounded-full bg-secondary-200 px-2 py-0.5 text-[11px] text-secondary-900 whitespace-nowrap">
                      {item.category}
                    </span>
                  </div>
                  <div className="mt-1.5 flex items-center gap-3 text-[11px] text-foreground-500">
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-fire-fill text-primary-500"></i>
                      热度 {item.heat}
                    </span>
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className={`${trendIcon[item.trend]} text-accent-600`}></i>
                      {item.delta}
                    </span>
                  </div>
                </div>
                <span className="hidden shrink-0 rounded-full bg-background-200 px-3 py-1 text-xs text-foreground-600 whitespace-nowrap sm:block">
                  热度曲线
                </span>
                <i className="ri-arrow-right-s-line text-lg text-foreground-400 transition-transform group-hover:translate-x-0.5"></i>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}